/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

class freeGift extends HTMLElement {
  constructor() {
    super();
    console.log(this);
    let el = this.querySelector("[data-promo]");
    el.addEventListener("click", function () {
      if (el.hasAttribute("disabled")) {
        return;
      }

      var variantID = el.getAttribute("data-variant");

      let formData = {
        items: [
          {
            id: variantID,
            quantity: 1,
          },
        ],
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((resp) => {
          return resp.json();
        })
        .then((data) => {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
            })
          );
        })
        .catch((err) => {
          console.error("Error: " + err);
        });
    });
  }
}

customElements.define("free-gift", freeGift);

document.addEventListener('product:added', (event) => {
  console.log('PRODUCT ADD TRIGGER');
  let price = event.detail.variant.price;
  let qty = event.detail.quantity;
  console.log(_tfa);
  _tfa.push({notify: 'event', name: 'add_to_cart', id: 1478112, revenue: price, currency: 'CURRENCY_PARAM', quantity: qty});
})

document.addEventListener('cart:refresh', (event) => {
  let checkOutButton = document.querySelector('[type="submit"][name="checkout"]');
if(checkOutButton){
  console.log(checkOutButton);
}
checkOutButton.addEventListener('click', () => {
  console.log('LELELE');
})
});

      // copy the text of the coupon on clicking in it
function copyCoupon() {
  // Get the text field
  var copyText = document.getElementById("coupon").value;

  // Copy the text inside the text field
  navigator.clipboard.writeText(copyText);

  document.getElementById("coupon-tooltip").style.display = "block";
  setTimeout(function () {
    document.getElementById("coupon-tooltip").style.display = "none";
  }, 1000);

  document.getElementById("coupon-tooltip-desktop").style.display = "block";
  setTimeout(function () {
    document.getElementById("coupon-tooltip-desktop").style.display = "none";
  }, 1000);
}
